import { Inject, Injectable } from '@angular/core';
import { IDataService, IParsedDataResponse } from '../../../../services/data/data-service.interface';
import { IEnvironmentService } from '../../../../services/environment/environment.interface';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { UrlOptionsByOfferId, UrlReplacerResponse } from './types';
import { map } from 'rxjs/operators';

@Injectable()
export class UrlReplacerService {
  public get optionsGroupedByOfferId$(): Observable<UrlOptionsByOfferId | null> {
    return this.optionsGroupedByOfferId$$.asObservable();
  }

  private endpointApi: string;
  private optionsGroupedByOfferId$$ = new BehaviorSubject<UrlOptionsByOfferId | null>(null);
  private globalData: IParsedDataResponse;

  constructor(
    @Inject('IDataService') protected readonly dataService: IDataService,
    @Inject('IEnvironmentService') private envService: IEnvironmentService,
    private http: HttpClient
  ) {
    this.endpointApi = this.envService.getVar('services.api') as string;
    this.globalData = this.dataService.getData();
  }

  public fetchOptions(url: string): Observable<UrlReplacerResponse | null> {
    if (!url) {
      this.optionsGroupedByOfferId$$.next(null);
      return of(null);
    }
    return this.http
      .post(`${this.endpointApi}/action/options`, {
        action: 'OfferUrl\\UpdateUrl',
        repository: 'Eloquent\\OfferUrlRepository',
        arguments: {
          from: url,
        },
      })
      .pipe(
        map((res: UrlReplacerResponse) => {
          this.optionsGroupedByOfferId$$.next(this.groupOptionsByOfferId(res));
          return res;
        })
      );
  }

  private groupOptionsByOfferId(response: UrlReplacerResponse): UrlOptionsByOfferId {
    const { offers, offer_urls } = this.globalData;
    return response.data.options.reduce((urlsByOffer, urlOption) => {
      if (!offers[urlOption.offer_id]) {
        return urlsByOffer;
      }
      const url = {
        name: offer_urls[urlOption.id],
        url: urlOption.url,
      };
      const urls = urlsByOffer.get(urlOption.offer_id);
      if (urls) {
        urls.matchedUrl.push(url);
      } else {
        urlsByOffer.set(urlOption.offer_id, { offer: offers[urlOption.offer_id], matchedUrl: [url] });
      }
      return urlsByOffer;
    }, new Map() as UrlOptionsByOfferId);
  }
}
